import { Injectable } from "@angular/core";
import { BaseNotesService, type Note, type DateLike } from "@classes/notes.class";
import { IFirmTaxprepT1Card, TaxprepT1Card } from "@app/views-interfaces";
import { getAnalyticsExtrasFromCard } from "../analytics-service";

export interface ITaxNote extends Note {
    createdAt: string;
    updatedAt: string;
    isImportedFromTaxprep: boolean;
}
@Injectable()
export class IfirmTaxNotesService extends BaseNotesService<ITaxNote> {
    protected dateField: keyof {
        [K in keyof ITaxNote as ITaxNote[K] extends DateLike ? K : never]: ITaxNote[K];
    } = "updatedAt";

    protected async getNotes(id: string): Promise<ITaxNote[]> {
        const result = await this.iframeMessagesService.postMessageResp("getNotes", { documentId: id }, "gotNotes");
        if (result.status === "success") return result.data;
        throw new Error("Failed to fetch notes");
    }

    protected async addNote(id: string, text: string): Promise<ITaxNote> {
        const result = await this.iframeMessagesService.postMessageResp("createNote", { documentId: id, text }, "noteCreated");
        if (result.status === "success") {
            this.trackNoteAdded();
            return result.response;
        }
        throw new Error("Failed to add notes");
    }

    protected async deleteNote(id: string, noteId: string): Promise<{ success: boolean }> {
        const result = await this.iframeMessagesService.postMessageResp("deleteNote", { documentId: id, noteId }, "noteDeleted");
        if (result.status === "success") return { success: true };
        throw new Error("Failed to delete notes");
    }

    protected sortNote(a: ITaxNote, b: ITaxNote): number {
        if (a.updatedAt > b.updatedAt) {
            return -1;
        } else if (a.updatedAt < b.updatedAt) {
            return 1;
        } else {
            return 0;
        }
    }

    private trackNoteAdded(): void {
        // TODO we are making an explicit type cast, which is overriding the type validation
        const card = this.cardModalService.currentCard() as IFirmTaxprepT1Card;
        this.analyticsService.track("Add a iFirmTaxprep note", getAnalyticsExtrasFromCard(card));
    }
}
